import { render, staticRenderFns } from "./BaseFieldError.vue?vue&type=template&id=70526efc"
import script from "./BaseFieldError.vue?vue&type=script&lang=js"
export * from "./BaseFieldError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports